import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";
import { CfcOrderRequest } from "../types";

export const SubmitCfcOrder = async (
  token: string,
  orderRequest: CfcOrderRequest,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  const response = await fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/electronic_orders/`,
    {
      method: "POST",
      body: JSON.stringify({
        is_cfc_order: true,
        source_req_identifier: orderRequest.source_req_identifier,
        lims_id: orderRequest.lims_id,
        npi: orderRequest.npi,
        ...(orderRequest.collection_date
          ? { collection_date: orderRequest.collection_date }
          : {}),
        selected_conditions: orderRequest.selected_conditions,
        is_O28_5_aneuploidy: orderRequest.is_O28_5_aneuploidy,
        other_aneuploidy_icd_10_codes:
          orderRequest.other_aneuploidy_icd_10_codes,
        is_mobile_phlebotomy: orderRequest.is_mobile_phlebotomy,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );

  return response;
};
